import { Colors } from '~/themes/colors';
import { IIconProps } from './Types';

export const CloseCircleSolidIcon = ({ color = Colors.secondary_500, size = 24 }: IIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
  >
    <g filter="url(#filter0_dd_10453_5351)">
      <circle cx="16" cy="15" r="12" fill={color} />
    </g>
    <path
      d="M13 18L16 15M16 15L19 12M16 15L13 12M16 15L19 18"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
